import Vue from "vue";
import Vuex from "vuex";
import VuexPersistence from "vuex-persist";

import Helpers from "@/utils/Helper";

Vue.use(Vuex);

// Setup : VuexPersistence
const vuexLocal = new VuexPersistence({
  storage: window.localStorage
});

export default new Vuex.Store({
  state: {
    user_profile: null,
    client: null,
    client_id: null,
    factsheet_id: null,
    factsheet_target: null,
    factsheet_retirement: null,
    factsheet_kids_education: null,
    factsheet_tax_planning: null,
    factsheet_insurance: null,
    factsheet_protection: null,
    factsheet_remark: null
  },
  getters: {
    children: state => {
      if (
        state.client &&
        state.client.family &&
        state.client.family.child &&
        state.client.family.child.length > 0
      ) {
        const kids = state.client.family.child;
        const result = Helpers.generateChildrenDummdyList(kids);
        return result;
      } else {
        return [];
      }
    },
    combinded_factsheet: state => {
      let request_object = {
        client_id: state.client_id,
        client: state.client,
        fact_info: {
          target: state.factsheet_target,
          plan_retirement: state.factsheet_retirement,
          plan_education: state.factsheet_kids_education,
          plan_tax: state.factsheet_tax_planning,
          plan_insurance: state.factsheet_insurance,
          plan_family: state.factsheet_protection,
          plan_summary: state.factsheet_remark
        }
      };
      if (state.factsheet_id) {
        request_object._id = state.factsheet_id;
      }
      return request_object;
    }
  },
  mutations: {
    SET_CLIENT_ID(state, payload) {
      state.client_id = payload;
    },
    SET_CLIENT_INFO(state, payload) {
      state.client = payload;
    },
    SET_FACTSHEET_TARGET(state, payload) {
      state.factsheet_target = payload;
    },
    EMPTY_FACTSHEET_TARGET(state) {
      state.factsheet_target = [];
    },
    SET_FACTSHEET_RETIREMENT(state, payload) {
      state.factsheet_retirement = payload;
    },
    SET_FACTSHEET_KID_EDUCATION(state, payload) {
      state.factsheet_kids_education = payload;
    },
    SET_FACTSHEET_TAX_PLANNING(state, payload) {
      state.factsheet_tax_planning = payload;
    },
    SET_FACTSHEET_INSURANCE(state, payload) {
      state.factsheet_insurance = payload;
    },
    SET_FACTSHEET_PROTECTION(state, payload) {
      state.factsheet_protection = payload;
    },
    SET_FACTSHEET_REMARK(state, payload) {
      state.factsheet_remark = payload;
    },
    SET_USER_PROFILE(state, payload) {
      state.user_profile = payload;
    },
    REMOVE_USER_PROFILE(state) {
      state.user_profile = null;
    },
    SET_EXISTING_FACTSHEET(state, payload) {
      state.factsheet_id = payload._id;
      state.client_id = payload.client._id;
      state.client = payload.client;
      state.factsheet_target = payload.fact_info.target;
      state.factsheet_retirement = payload.fact_info.plan_retirement;
      state.factsheet_kids_education = payload.fact_info.plan_education;
      state.factsheet_tax_planning = payload.fact_info.plan_tax;
      state.factsheet_insurance = payload.fact_info.plan_insurance;
      state.factsheet_protection = payload.fact_info.plan_family;
      state.factsheet_remark = payload.fact_info.plan_summary;
    },
    CLEAR_FACTSHEET_PROPERTIES(state) {
      state.factsheet_id = null;
      state.client_id = null;
      state.client = null;
      state.factsheet_target = null;
      state.factsheet_retirement = null;
      state.factsheet_kids_education = null;
      state.factsheet_tax_planning = null;
      state.factsheet_insurance = null;
      state.factsheet_protection = null;
      state.factsheet_remark = null;
    },
    UPDATE_KIDS_INFO(state, payload) {
      if (state.factsheet_kids_education && payload && payload.length > 0) {
        for (let i = 0; i < state.factsheet_kids_education.length; i++) {
          const updated_kid_edu_info = payload[i];
          const kid_edu_info = state.factsheet_kids_education[i];
          kid_edu_info.name = updated_kid_edu_info.name;
          kid_edu_info.gender = updated_kid_edu_info.gender;
          kid_edu_info.sequence = updated_kid_edu_info.sequence;
          kid_edu_info.dob = updated_kid_edu_info.dob;
        }
      } else {
        state.factsheet_kids_education = [];
      }
    }
  },
  plugins: [vuexLocal.plugin]
});
